import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { StorageService } from 'src/app/providers/storage.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { AlertService } from '../../providers/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { AddFreeSubComponent } from './add-free-sub/add-free-sub.component';
import { SharedService } from '../../providers/shared.service';

@Component({
  selector: 'sm-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SubscriptionComponent implements OnInit, OnDestroy {
  searchInput: FormControl = new FormControl('', [Validators.required, Validators.minLength(13)]);
  private _apiSubscription: Subscription;
  isFetching: boolean = false;
  subscriptionData: any;
  businessAddCredit: number = 0;
  employeeAddCredit: number = 0;
  allNull : boolean = false
  clickEventSubscription: Subscription;
  constructor(
    private _navService: NavigationService,
    private _apiService: ApiService,
    private _storageService: StorageService,
    private _router: Router,
    private _activeRoute: ActivatedRoute,
    private _alertService: AlertService,
    private dialog: MatDialog,
    private sharedService: SharedService
  ) {
    this._navService.hideSidebarAndNav = false;
    this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
      this.ngOnInit();
    })
    this._apiSubscription = this._apiService.apiResult.subscribe(resData => {
    
      
      if (resData.responseType === SM_CONSTANTS.GET_SUBSCRIPTION_DETAIL_RESULT) {
        console.log(resData);
        this.subscriptionData = resData.result ? resData.result[0] : resData.result;

        if (this.subscriptionData != null) {
          if(this.subscriptionData.businessSubsInfo == null && this.subscriptionData.subscriptionInfo == null &&
             this.subscriptionData.userSubsInfo == null &&  this.subscriptionData.userSubsInfo == null){
              this.allNull = true
              this._alertService.onOpenSnackbar("There is some issue with the system. Try again");
             }

          if(this.subscriptionData.businessSubsInfo != null){
          this.subscriptionData.businessSubsInfo = JSON.parse(this.subscriptionData.businessSubsInfo);
          this.subscriptionData.businessSubsInfo = this.subscriptionData.businessSubsInfo.sort((dataA:any, dataB:any) =>
          ((+new Date(dataB['creationDate'])) - (+new 
          Date(dataA['creationDate']))))
          }

          if(this.subscriptionData.subscriptionInfo != null){
          this.subscriptionData.subscriptionInfo = JSON.parse(this.subscriptionData.subscriptionInfo);
          this.subscriptionData.subscriptionInfo = this.subscriptionData.subscriptionInfo.sort((dataA:any, dataB:any) =>
          ((+new Date(dataB['creationDate'])) - (+new 
          Date(dataA['creationDate']))))
          }
          if(this.subscriptionData.transInfo != null){
          this.subscriptionData.transInfo = JSON.parse(this.subscriptionData.transInfo);
          this.subscriptionData.transInfo = this.subscriptionData.transInfo.sort((dataA:any, dataB:any) =>
          ((+new Date(dataB['creationDate'])) - (+new 
          Date(dataA['creationDate'])))
   
       )}

          if(this.subscriptionData.userSubsInfo != null){
            this.subscriptionData.userSubsInfo = JSON.parse(this.subscriptionData.userSubsInfo);
            this.subscriptionData.userSubsInfo = this.subscriptionData.userSubsInfo.sort((dataA:any, dataB:any) =>
          ((+new Date(dataB['creationDate'])) - (+new 
          Date(dataA['creationDate']))))
          }
        

          if(this.subscriptionData.subscriptionInfo != null){
             this.subscriptionData.subscriptionInfo.forEach((sub: any) => {
            if (sub.isEntityPlan) {
              this.businessAddCredit = this.businessAddCredit + (sub.noOfEntity - sub.noOfEntityActivate);
            } else {
              this.employeeAddCredit = this.employeeAddCredit + (sub.noOfUsers - sub.noOfUsersActivate);
            }
          });
          }
        this._storageService.setValueInAppStorage(SM_CONSTANTS.USER_SUBSCRIPTION_DATA, JSON.stringify(this.subscriptionData));
        }
        else if(this.subscriptionData === null){
          this._alertService.onOpenSnackbar("There is some issue with the system. Try again");
        }
        this.isFetching = false;
      }
    });
  }

  ngOnInit(): void {
    this._activeRoute.queryParams.subscribe((param:Params) =>{
     if(param['id']){
      this.isFetching = true;
      this.searchInput.setValue(param['id']);
      // this._apiService.getSubscriptionDetail(this.searchInput.value);
      this._apiService.getSubscriptionDetail(sessionStorage.getItem('subscriptionPhone')!);
     }
    });
    // this._apiService.getSubscriptionDetail(sessionStorage.getItem('subscriptionPhone')!);
  }

  onGetSubscription(){
    console.log(this.searchInput.value);
    
    sessionStorage.setItem('subscriptionPhone', this.searchInput.value)
    this.businessAddCredit = 0
    this.employeeAddCredit = 0
    this.allNull = false
    this._router.navigate(['/subscription'], {queryParams: {id: this.searchInput.value}, });
  }

  addFreeSubscription(){
    let dialogRef = this.dialog.open(AddFreeSubComponent, {

      height: '350px',
      width: '500px',
      disableClose: true,
      data: {
        ref: this.dialog,
        data:this.subscriptionData
      }
    });
  }

  ngOnDestroy(){
    this._apiSubscription.unsubscribe();
    this.clickEventSubscription.unsubscribe()
  }

}
